import React, { FC, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import { themeOptions } from "styles/theme";
import { DATATEST } from "constants/integration";

import type { IHeaderParams } from "ag-grid-community";
import type { ISizeHeaderPrices } from "types/cart/shipment-review";

interface IProps extends IHeaderParams {
    priceDetails?: ISizeHeaderPrices;
}

export const CustomDetailsHeader: FC<IProps> = (props) => {
    const { priceDetails, displayName } = props;
    const prices = useMemo<string>(() => (priceDetails?.prices ?? []).join(" - "), [priceDetails?.prices]);

    const classes = useStyles();
    return (
        <div className={classes.cellContainer}>
            <div className={classes.cellLine}>{displayName}</div>
            <div
                className={classNames(
                    classes.cellLine,
                    classes.price,
                    priceDetails?.discount && classes.priceDiscounted,
                )}
                data-test={DATATEST.SHIPMENT_REVIEW.DETAILS_HEADER_PRICE}
            >
                {prices}
            </div>
        </div>
    );
};

const useStyles = makeStyles({
    cellContainer: {
        color: themeOptions.palette.textColor,
        textAlign: "right",
    },
    cellLine: {
        lineHeight: "15px",
    },
    price: {
        fontWeight: "normal",
    },
    priceDiscounted: {
        color: "green",
    },
});
